module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon",
    class: [_vm.type, _vm.size]
  }, [_c('i', {
    class: [_vm.newPack, _vm.newPack === 'fa' ? ("fa-" + _vm.newIcon) : null]
  }, [_vm._v(_vm._s(_vm.newPack === 'mdi' ? _vm.newIcon : null))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-200738ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/buefy/src/components/icon/Icon.vue
// module id = 394
// module chunks = 56